// Module
var code = "<div class=\"\"> <p class=\"text-center kokokakakoko\">Kitstajm FTW!</p> </div> ";
// Exports
export default code;